import React, {FC} from 'react';
import {DnDCardProps} from "../../types/types";
import classes from "./DnDCard.module.css";
import Card from "../Card/Card";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from '@dnd-kit/utilities';

export const DnDCard: FC<DnDCardProps> = ({ id, index, moveCard, ...props }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({id: props.card.id});


    const style = {
        transform: CSS.Transform.toString(transform),
        transition,

    };
    
    return (
        <div ref={setNodeRef} style={style} className={classes.card}>
            <button {...listeners} {...attributes} className={classes.button}>
                <svg viewBox="0 0 20 20" width="12" className={classes.svg}>
                    <path
                        d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z">
                    </path>
                </svg>
            </button>
            <Card key={props.card.id} card={props.card} config={props.config} className={props.className}/>
        </div>
    )
}
export default DnDCard;